import { FormInput, Loader } from "@/components";
import { Button } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useForgotPassword from "./useForgotPassword";
import logo from "@/assets/logo.png";
import emailSuccess from "@/assets/emailSuccess.png";
import { EMAIL_ID } from "./consts";

const ForgotPassword = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isForgotPasswordPending,
    onEmailSentOkClick,
    showEmailMsg,
  } = useForgotPassword();
  const { errors } = form.formState;

  return (
    <div className="flex md:flex-row w-full h-[100vh]">
      <div className="hidden bg-[url('/loginCover.png')] bg-cover bg-no-repeat md:flex flex-col w-1/2 bg-blue-900 text-white p-8 relative">
        <div className="absolute z-10 bg-linear-to-br from-secondary to-primary-700 opacity-[00.9] h-full w-full top-0 left-0"></div>
        <img src={logo} className="h-auto w-40 z-20" />
      </div>
      <div
        className={`w-full md:w-1/2 bg-[url('/loginCoverRight.png')] bg-cover bg-no-repeat`}
      >
        <div className="bg-[url('/loginCoverObjects.png')] bg-cover bg-no-repeat flex flex-col justify-center items-center p-8 h-full">
          {showEmailMsg ? (
            <Card className="w-full lg:w-[400px]">
              <CardHeader className="my-[20px] flex flex-col items-center justify-center">
                <img src={emailSuccess} className="stroke-3" />
                <CardTitle className="text-center font-[500] text-[16px] ">
                  Email sent successfully with temporary password
                </CardTitle>
              </CardHeader>
              <CardContent></CardContent>
              <CardFooter>
                <Button
                  type="button"
                  className="w-full"
                  disabled={isForgotPasswordPending}
                  onClick={onEmailSentOkClick}
                >
                  Ok
                </Button>
              </CardFooter>
            </Card>
          ) : (
            <FormProvider {...form}>
              <form onSubmit={form.handleSubmit(onSubmit)}>
                <Card className="w-full lg:w-[400px]">
                  <CardHeader className="my-[20px]">
                    <CardTitle className="text-center font-[500] text-[24px]">
                      Forgot Password
                    </CardTitle>
                    <span className="text-[14px] text-g-400 text-center font-extralight">
                      Please enter registered email ID
                    </span>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-col-1 gap-5">
                      <div>
                        <FormInput
                          name={EMAIL_ID}
                          label="Email Address"
                          control={form.control}
                          placeholder="Please enter"
                          error={errors[EMAIL_ID]?.message}
                          isRequired={requiredFields.includes(EMAIL_ID)}
                        />
                      </div>
                    </div>
                  </CardContent>
                  <CardFooter>
                    <Button
                      type="submit"
                      className="w-full"
                      disabled={isForgotPasswordPending}
                    >
                      {isForgotPasswordPending ? (
                        <Loader variant="secondary" />
                      ) : (
                        ""
                      )}{" "}
                      Send Email
                    </Button>
                  </CardFooter>
                </Card>
              </form>
            </FormProvider>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
